export enum SSEEventTypesEnum {
  OST_UPDATED_SUB_STATE = "OST_UPDATED_SUB_STATE",
  OST_STATE = "OST_STATE",
  F11_NUM = "F11_NUM",
  PRODUCT_STATE = "PRODUCT_STATE",
  F11_STATE = "F11_STATE",
  GUIA_DESPACHO = "GUIA_DESPACHO",
  OST_IS_F11_EMPRESA = "OST_IS_F11_EMPRESA",
  LABEL_CREATED = "LABEL_CREATED",
  MANIFEST_CREATED = "MANIFEST_CREATED",
  GIFTCARD_STATUS_CHANGED = "GIFTCARD_STATUS_CHANGED",
  OST_FILE_IMAGE_UPLOADED = "OST_FILE_IMAGE_UPLOADED",
}
